import { useEffect } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { trpc, trpcClient } from '@/shared/lib/trpc'
import { queryClient } from '@/shared/lib/queryClient'
import { AuthProvider } from '@/shared/context/AuthContext'
import { OperatorModeProvider } from '@/shared/context/OperatorModeContext'
import { OfflineProvider } from '@/shared/context/OfflineContext'
import { ThemeProvider } from '@/shared/context/ThemeContext'
import { OrderProvider } from '@/shared/context/OrderContext'
import { RestockProvider } from '@/shared/context/RestockContext'
import { AdjustmentProvider } from '@/shared/context/AdjustmentContext'
import { AppRouter } from './routes'

function SilentSwUpdate() {
  const { needRefresh: [needRefresh], updateServiceWorker } = useRegisterSW()
  useEffect(() => {
    if (needRefresh) updateServiceWorker(false)
  }, [needRefresh])
  return null
}

export function App() {
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider>
            <OperatorModeProvider>
            <OfflineProvider>
              <OrderProvider>
                <RestockProvider>
                  <AdjustmentProvider>
                    <SilentSwUpdate />
                    <AppRouter />
                  </AdjustmentProvider>
                </RestockProvider>
              </OrderProvider>
            </OfflineProvider>
            </OperatorModeProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </trpc.Provider>
  )
}
